import { useMutation, useQuery } from '@tanstack/react-query';
import { AuthProtocolLoginResponse } from '~/swagger/data-contracts';
import { authApi, getAuth, setAuth } from './';

export const QueryKeyAuth = 'auth';
const queryOptions = { refetchOnWindowFocus: false };

export const useLoginMutation = () => {
  return useMutation(authApi.loginCreate, {
    onSuccess: (response) => {
      const authData: AuthProtocolLoginResponse = {
        accessToken: response.data.accessToken,
        refreshToken: response.data.refreshToken,
      };

      setAuth(authData);
    },
  });
};

export const useUserInfoQuery = () => {
  const auth = getAuth();

  return useQuery(
    [QueryKeyAuth, 'user-info', auth?.accessToken],
    async () => {
      if (auth?.accessToken && auth.refreshToken) {
        const { data } = await authApi.infoList();
        return data;
      } else {
        return undefined;
      }
    },
    queryOptions
  );
};

export const useLoginOktaMutation = () => {
  return useMutation(authApi.loginOktaCreate, {
    onSuccess: (response) => {
      const authData: AuthProtocolLoginResponse = {
        accessToken: response.data.accessToken,
        refreshToken: response.data.refreshToken,
      };

      setAuth(authData);
    },
  });
};

export const useSetClientViewAuthMutation = () =>
  useMutation({
    onMutate: (token: string) => {
      setAuth(JSON.parse(token), true);
    },
  });
